var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "190.217 172.808 36 36",
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 2,
    height: 2,
    className: "clr-i-outline clr-i-outline-path-1",
    transform: "matrix(1, 0, 0, 1, 190.21727, 172.8078)",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 2,
    height: 2,
    className: "clr-i-outline clr-i-outline-path-2",
    transform: "matrix(1, 0, 0, 1, 190.21727, 172.8078)",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 2,
    height: 2,
    className: "clr-i-outline clr-i-outline-path-3",
    transform: "matrix(1, 0, 0, 1, 190.21727, 172.8078)",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,4H4A2,2,0,0,0,2,6V30a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V6A2,2,0,0,0,32,4ZM4,6H32v4.2H4ZM4,30V11.8H32V30Z",
    className: "clr-i-outline clr-i-outline-path-4",
    transform: "matrix(1, 0, 0, 1, 190.21727, 172.8078)",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fillOpacity: 0,
    transform: "matrix(1, 0, 0, 1, 190.21727, 172.8078)",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.e1aadb93e0db54ff8ac962c4c07c9c90.svg";
export { ForwardRef as ReactComponent };